import { getContext } from "svelte";
import type { GlobalTemplateProps } from "./GlobalTemplateProps.js";
import { globalTemplatePropsContextKey } from "./globalTemplatePropsContextKey.js";

export function getGlobalTemplateProps(): GlobalTemplateProps {
	return getContext<GlobalTemplateProps>(globalTemplatePropsContextKey);
}
